import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import EventIcon from '@material-ui/icons/Event';
import {
  Divider,
  Grid,
  Box,
  Typography,
  Chip,
  Link,
  Tooltip,
  TextField,
  FormControl,
  GridSize,
} from '@material-ui/core';

/**
 * Create a small subtitle, used for Entity Names.
 */
export function SmallSubTitle({ name, icon, display = 'block', styleProps }) {
  return (
    <span style={{ color: 'inherit', fontSize: 11, display, alignItems: 'center', ...styleProps }}>
      {icon}&nbsp;{name}
    </span>
  );
}

export function VerifiedDetails({ verifiedBy, verifiedAt }) {
  return (
    <div style={{ display: 'inline-flex', verticalAlign: 'middle' }}>
      <Grid container justify="center" alignItems="center">
        <Grid item>
          <SmallSubTitle
            display="block"
            name={verifiedBy}
            icon={
              <AccountCircleIcon
                style={{
                  fontSize: '15px',
                  display: 'inline-flex',
                  verticalAlign: 'middle',
                }}
                color="primary"
              />
            }
            styleProps={{ margin: '0px 0px 0px 5px' }}
          />
          <SmallSubTitle
            display="block"
            name={verifiedAt}
            icon={
              <EventIcon
                style={{
                  fontSize: '15px',
                  display: 'inline-flex',
                  verticalAlign: 'middle',
                }}
                color="primary"
              />
            }
            styleProps={{ margin: '5px 0px 0px 5px' }}
          />
        </Grid>
      </Grid>
    </div>
  );
}
